package amazon.lastmile.inject

import app.nestbridge.feature.progress.ui.ProgressUiFactory
import com.slack.circuit.runtime.ui.Ui
import me.tatarka.inject.annotations.IntoSet
import me.tatarka.inject.annotations.Provides
import software.amazon.lastmile.kotlin.inject.anvil.`internal`.Origin

@Origin(value = ProgressUiFactory::class)
public interface AppNestbridgeFeatureProgressUiProgressUiFactory {
  @Provides
  @IntoSet
  public fun provideProgressUiFactoryFactoryMultibinding(progressUiFactory: ProgressUiFactory): Ui.Factory = progressUiFactory
}
